import type { AppRouteModule } from '/@/router/types';

import { LAYOUT } from '/@/router/constant';
import { t } from '/@/hooks/web/useI18n';

const index: AppRouteModule = {
  path: '/index',
  name: 'Index',
  component: LAYOUT,
  redirect: '/index',
  meta: {
    orderNo: 2000,
    icon: 'ion:settings-outline',
    title:'首页',
  },
  children: [
    {
      path: 'index',
      name: 'IndexManagement',
      meta: {
        title: '首页',
        ignoreKeepAlive: true,
      },
      component: () => import('/@/views/index/index.vue'),
    },
   
   
  ],
};

export default index;
